<script setup>
import LogoutTime from '@/layouts/components/LogoutTime.vue'
import UserProfile from '@/layouts/components/UserProfile.vue'

import { useRoute, useRouter } from 'vue-router'

console.log("1122-1")
definePage({
  meta: {
    layout: 'blank',
    action: 'read',
    subject: 'project',
  },
})
console.log("1122-2")

import CardView from '@/views/projects/cardView.vue'
import DeleteList from '@/views/projects/deleteList.vue'
import ListView from '@/views/projects/listView.vue'

const route = useRoute()
const router = useRouter()
const currentTab = ref('tab-1')
const key = ref(0)

const hover = ref(false)

const reloadList = () => {
  key.value++
}
</script>

<template>
  <VCard
    class=""
    style="border-radius: 0;"
  >
    <VCardText class="d-flex justify-space-between align-center py-2 ">
      <div
        class="d-flex align-center cursor-pointer"
        @click="router.push('/projects')"
      >
        <img
          src="/images/home_logo.png"
          alt="홈"
          width="87"
          height="30"
          style="display:block"
        >
      </div>

   
      <!-- 오른쪽 기존 요소 -->
      <div class="d-flex align-center">
        <LogoutTime class="me-2" />
        <UserProfile />
        <template v-if="$can('read', 'manage-permission')">
          <div
            style="
        background-color: rgba(0,0,0,10%);
        block-size: 30px;
        inline-size: 1px;
        margin-inline: 15px;
      "
          />

          <div
            class="d-flex align-center px-2 py-1"
            style="
          border-radius: 6px;
          cursor: pointer;
          padding-inline-start:20px;
          transition: background-color 0.2s;
        "
            :style="{ backgroundColor: hover ? 'rgba(0,0,0,0.05)' : 'transparent' }"
            @click="(e) => { 
              console.log('resolve by name:', router.resolve({ name: 'manage-permissions' }))
              console.log('resolve by path:', router.resolve('/manage/permissions'))

              console.log('[manage] click', { from: route?.fullPath, to: '/manage/permissions', event: e }); 
              router.push('/manage/permissions'); 
            }"
            @mouseover="() => { 
              hover = true; 
              console.log('[manage] mouseover', { hover }); 
            }"
            @mouseleave="() => { 
              hover = false; 
              console.log('[manage] mouseleave', { hover }); 
            }"
          >
            <img
              src="/images/settings.png"
              alt="관리"
              style=" block-size: 20px;inline-size: 20px; margin-inline-end: 4px;"
            >
            <span style=" color: #4B5563;font-size: 14px;">관리</span>
          </div>
        </template>
      </div>
    </VCardText>
  </VCard>
  <VRow class="my-8 projectrow">
    <VCol class="projectcol">
      <!--
        프로젝트 대시보드
        <VTabs
        v-model="currentTab"
        align-tabs="end"
        >
        <VTab>
        <img
        src="/images/grid-active.svg"
        alt="그리드"
        class="w-6 h-6"
        >
        </VTab>

        <VTab>
        <img
        src="/images/list-default.svg"
        alt="리스트"
        class="w-6 h-6"
        >
        </VTab>

        <VTab v-if="$can('write', 'project')">
        <img
        src="/images/trash-default.svg"
        alt="종료된 시험"
        class="w-6 h-6"
        >
        <VTooltip
        activator="parent"
        location="top"
        >
        종료된 시험
        </VTooltip>
        </VTab> 

        </VTabs>
      -->

      <div class="tab-container">
        <div class="d-flex align-center projects">
          프로젝트 목록
        </div>
        <div class="d-flex align-center">
          <div class="tab-wrapper">
            <VBtnToggle
              v-model="currentTab"
              class="tab-toggle"
              mandatory
              divided
              borderless
            >
              <VBtn
                :value="0"
                class="tab-btn"
                icon
              >
                <img :src="currentTab === 0 ? '/images/grid-active.svg' : '/images/grid-default.svg'">
              </VBtn>

              <VBtn
                :value="1"
                class="tab-btn"
                icon
              >
                <img :src="currentTab === 1 ? '/images/list-active.svg' : '/images/list-default.svg'">
              </VBtn>

              <VBtn
                v-if="$can('write', 'manage-user')"
                :value="2"
                class="tab-btn"
                icon
              >
                <img :src="currentTab === 2 ? '/images/archive_active.png' : '/images/archive.png'">
              </VBtn>
            </VBtnToggle>
          <!-- 하단 border (underline) -->
          </div>


          <VBtn
            v-if="$can('write', 'project')"
          
            append-icon="tabler-plus"
          
            color="#3857F5"
            class="custom-btn-36"
            @click="$router.push('/projects/create')"
          >
            {{ $t("Add Project") }} 
          </VBtn>
        </div>
        <div
          class="tab-underline"
          :style="{ left: underlineLeft }"
        />
      </div>
   
      <VWindow
        v-model="currentTab"
        class="disable-tab-transition"
      >
        <VWindowItem value="0">
          <CardView :key="key" @reload="reloadList" />
        </VWindowItem>
        <VWindowItem value="1">
          <ListView
            :key="key"
            @reload="reloadList"
          />
        </VWindowItem>
        <VWindowItem value="2">
          <DeleteList
            :key="key"
            @reload="reloadList"
          />
        </VWindowItem>
      </VWindow>
    </VCol>
  </VRow>
</template> 



<style scoped>
.tab-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block-end : 20px;
  padding-block: 0;
  padding-block-end : 20px; 
}

.projects{
  font-size: 22px;
  font-weight: bold;
}

.tab-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 10px;
  background-color: #f4f6fa;
}

.tab-toggle {
  display: flex;
  border: 1px solid #E8ECEF;  
  border-radius: 6px;
  block-size: 36px;

  /* 그림자1 */
  box-shadow: 0 3px 8px 0 rgba(201, 201, 201, 25%);
}

.tab-btn {
  position: relative;
  block-size: 36px;
  inline-size: 42px;
  transition: background-color 0.2s;
}

.tab-btn.v-btn--active {
  background-color: #eef0ff !important;
}

.tab-btn img {
  block-size: 16px;
  inline-size: 16px;
}

/* 하단 밑줄 */
.tab-underline {
  position: absolute;
  background-color: #DAE6EE;
  block-size: 1px;
  inline-size: 100%;
  inset-block-end: 0;    
  transition: inset-inline-start 0.3s ease;
}

.custom-btn-36{
  block-size: 36px !important;
  min-block-size: 36px !important;
}

.projectcol{
  margin-block: 0;
  margin-inline: auto; 
}

.projectrow{
  margin-inline: 34px;
}
</style>
